import React from 'react';
import extbanner from '../../assets/images/extbanner.jpeg';
function Banner() {
  return (
    <div className="w-screen max-w-full h-auto md:min-h-[75vh] flex flex-wrap">
      <div className="basis-full md:basis-1/3 h-auto p-4 md:p-0 bg-indigo-100 flex items-center justify-center">
        <div className="w-full md:w-3/4 h-full md:h-2/3">
          <h1 className="font-bold md:pb-4 text-2xl md:text-5xl">
            <span className="text-xs font-light block">Acerca de</span>
            Nosotros
          </h1>
          <p className="my-2 font-light text-sm md:text-base text-gray-600 hidden md:block">
            Con sede en Córdoba, Argentina, Fabrilum cuenta con más de 10 años
            de experiencia en diseño, fabricación y comercialización de
            artículos de iluminación. Enfocados en la calidad y las
            terminaciones, creamos productos duraderos y esteticos. Nos
            destacamos por nuestra atención personalizada y flexibilidad,
            adaptándonos a tus necesidades. Creemos en el futuro de la Argentina
            y seguimos apostando a la industria nacional comprometidos con la
            excelencia en la producción de luminarias.
          </p>
          <span className="pb-2 mt-6 inline-block cursor-pointer border-b border-solid border-gray-300 hidden md:block">
            <a href="mailto:info@fabrilum.com.ar?Subject=Quiero ser cliente">
              Quiero ser cliente
            </a>
          </span>
        </div>
      </div>
      <div className="basis-full md:basis-2/3 grow-0 overflow-hidden">
        <img className="w-full" src={extbanner} />
      </div>
      <div className="basis-full md:basis-1/3 h-auto p-4 md:p-0 bg-indigo-100 flex items-center justify-center">
        <div className="w-full md:w-3/4 h-full md:h-1/2">
          <p className="my-2 font-light text-sm md:text-base text-gray-600  md:hidden">
            Con sede en Córdoba, Argentina, Fabrilum cuenta con más de 10 años
            de experiencia en diseño, fabricación y comercialización de
            artículos de iluminación. Enfocados en la calidad y las
            terminaciones, creamos productos duraderos y esteticos. Nos
            destacamos por nuestra atención personalizada y flexibilidad,
            adaptándonos a tus necesidades. Creemos en el futuro de la Argentina
            y seguimos apostando a la industria nacional comprometidos con la
            excelencia en la producción de luminarias.
          </p>
          <span className="pb-2 mt-6 inline-block cursor-pointer border-b border-solid border-gray-300 md:hidden">
            <a href="mailto:info@fabrilum.com.ar?Subject=Quiero ser cliente">
              Quiero ser cliente
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
export default Banner;
